// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"7f3296c5","453":"373e2563","526":"182538cb","551":"eb096328","679":"f4d1586b","684":"1c18c926","812":"e2f578a0","828":"af3fa20f","860":"b36ae3b2"}[chunkId] + ".chunk.js";
};